import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PersonalizedProgram = lazyWithPreload(
  () => import('./PersonalizedProgram'),
)
